import React from 'react';
import { Button } from './ui/button';
import { LayoutGrid, List, CalendarDays } from 'lucide-react';

/**
 * Reusable Card/List/Calendar view toggle component
 * Uses BookingFlows brand blue (#2563EB) for active state
 * Soft card-like shadow for consistent styling
 */
const CardListViewToggle = ({ viewMode, onViewModeChange, showCalendar = false }) => {
  const activeStyle = { background: '#2563EB', color: 'white' };
  const inactiveStyle = { background: 'white', color: '#374151' };
  
  return (
    <div className="flex gap-1 items-center bg-white rounded-lg p-1 shadow-[0_8px_24px_rgba(0,0,0,0.04)] border border-gray-100">
      {showCalendar && (
        <Button
          variant={viewMode === "calendar" ? "default" : "ghost"}
          size="sm"
          onClick={() => onViewModeChange("calendar")}
          style={viewMode === "calendar" ? activeStyle : inactiveStyle}
          className="h-9 w-9 p-0 flex items-center justify-center"
          data-testid="view-mode-calendar"
          aria-label="Calendar view"
          title="Calendar view"
        >
          <CalendarDays className="w-4 h-4" />
        </Button>
      )}
      <Button
        variant={viewMode === "card" ? "default" : "ghost"}
        size="sm"
        onClick={() => onViewModeChange("card")}
        style={viewMode === "card" ? activeStyle : inactiveStyle}
        className="h-9 w-9 p-0 flex items-center justify-center"
        data-testid="view-mode-card"
        aria-label="Card view"
        title="Card view"
      >
        <LayoutGrid className="w-4 h-4" />
      </Button>
      <Button
        variant={viewMode === "list" ? "default" : "ghost"}
        size="sm"
        onClick={() => onViewModeChange("list")}
        style={viewMode === "list" ? activeStyle : inactiveStyle}
        className="h-9 w-9 p-0 flex items-center justify-center"
        data-testid="view-mode-list"
        aria-label="List view"
        title="List view"
      >
        <List className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default CardListViewToggle;
